export const ITEM_ROUTING_OPTION_FIELD_NAME = 'itemRoutingOption';
export const PREPAYMENT_FIELD_NAME = 'prepayment';
export const COMPANY_FIELD_NAME = 'company';
export const PRODUCT_CATEGORY_IDS_FIELD_NAME = 'productCategoryIds';
export const ITEM_TYPES_FIELD_NAME = 'itemTypes';
export const SERVICE_FIELD_NAME = 'selectedServiceId';
export const BILL_ASSIGNMENT_TARGET_OPTION_FIELD_NAME = 'assignmentTargetType';
export const TRIGGER_TYPE_OPTION_FIELD_NAME = 'triggerType';
export const BILL_AGGREGATION_TYPE_OPTION_FIELD_NAME = 'billAggregationType';
export const NAME_FIELD_NAME = 'name';
